import React from 'react';
import { Link } from 'react-router-dom';

/* 2026-10-08 3:53 PM ET: GET /api/v1/admin/user/null returned 500 (Sentry paged). The admin console builds user
   links straight from row fields (`/user/${row.gopher_id}`), so a row with no id — an order with no Gopher yet has
   gopher_id null — produced the literal path /user/null. The backend now answers that 400 (gopher-backend-api !707),
   but the link itself was still a link that can only fail.

   SafeLink is react-router's <Link> and nothing else, EXCEPT that a link to /user/<something that is not a number>
   renders its label as plain text. Files that build user links import it as `Link`, so every site is covered
   without hand-patching each one, and every other link behaves exactly as before. */
export const isDeadUserPath = (to) =>
  typeof to === 'string' && /^\/user\/(?!\d+(?:[/?#]|$))/.test(to);

const SafeLink = ({ to, children, style, className, ...rest }) => {
  if (isDeadUserPath(to)) {
    return (
      <span style={style} className={className} title="No user on this record">
        {children}
      </span>
    );
  }
  return (
    <Link to={to} style={style} className={className} {...rest}>
      {children}
    </Link>
  );
};

export default SafeLink;
